import React from "react"
import HomeView from "../../components/HomeView"
import ContentPage from "../../components/content-page"
import PropTypes from "prop-types"
import Meta from "../../components/meta"

const index = ({ location }) => {
	return (<ContentPage>
		<Meta title="Home" description="Bawa Brand Masale is an offshoot of the masala giant, Bawa Masala Company (BMC), estd. 1952. Bawa Masala premium spice products and dealerships available pan-India." location={location} />
		<HomeView location={location} />
	</ContentPage>)
}

index.propTypes = {
	location: PropTypes.object
}

export default index



// WEBPACK FOOTER //
// ./src/pages/home/index.jsx